import React from "react";
import {
 Matters,
  Apply,
  ProInsight,
  SMartTip,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";

const TipCardView = ({
  mindfulnessStepsData = {},
}) => {
    const {t} = useTranslation();
  const nutrientData = [
    {
      label:t("1. Why It Matters"),
      key: "setup",
      icon: <Matters className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.["Why It Matters"],
    },
    {
      label: t("2. How to Apply It"),
      key: "focus",
      icon: <Apply className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.["How to Apply It"],
    },
    {
      label: t("3. Smart Tip"),
      key: "awareness",
      icon: <SMartTip className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.["Smart Tip"],
    },
    {
      label:t( "4. Pro Insight"),
      key: "gentle_return",
      icon: <ProInsight className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.["Pro Insight"],
    },
  ];
  // Original layout (non-dashboard)
  return (
    <div className=" rounded-lg mt-6">
      {/* First Row - 3 cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
        {nutrientData
          .map(({ label, icon, value, tabColor }, index) => (
            <Card
              key={index}
              label={label}
              icon={icon}
              value={value}
              tabColor={tabColor}
            />
          ))}
      </div>
    </div>
  );
};

// Card component for reusability
const Card = ({ label, icon, value, tabColor }) => (
  <div
    className="py-5 px-2 rounded-[17px] bg-white border border-[#E6E6E6] flex items-center xl:items-start flex-col xl:flex-row justify-center gap-2 overflow-hidden"
    style={{
      boxShadow: "7px 7px 9.5px 0px #0000000D",
    }}
  >
    <div className="flex justify-center">
      <div
        className="rounded-full min-w-11 min-h-11 max-w-11 max-h-11 flex items-center justify-center"
        style={{
          backgroundColor: tabColor,
        }}
      >
        {icon}
      </div>
    </div>
    <div>
      <p className="text-[12px] md:text-[16px] font-[500] font-[Lato] text-[#6C6A6A] text-center xl:text-start">
        {label}
      </p>
      <div>
        <p
          className="text-[12px] md:text-[16px] font-[500] font-[Lato] text-[#898787] text-center xl:text-start"
          style={{
            wordBreak: "break-word",
            hyphens: "auto",
            overflowWrap: "break-word",
          }}
        >
          {value}
        </p>
      </div>
    </div>
  </div>
);


export default TipCardView;
